import React from "react";

const BunyanTextLogo = ({ height = 38, width = 183 }) => {
  return (
    <svg
      height={height}
      width={width}
      viewBox="0 0 183 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_4774_62783)">
        <path
          d="M63.3675 15.8853C64.0271 17.0145 65.4743 17.6313 66.8122 17.6313C69.493 17.6313 71.7467 15.5483 71.7467 12.3978C71.7467 9.24739 69.512 7.18817 66.8122 7.18817C65.4078 7.18817 64.0271 7.78601 63.3675 8.91051V2.0354H61.2847V17.3704H63.3675V15.8806V15.8853ZM66.556 9.13826C68.2784 9.13826 69.6401 10.5 69.6401 12.3694C69.6401 14.2389 68.2784 15.667 66.556 15.667C64.8337 15.667 63.3865 14.3717 63.3865 12.3694C63.3865 10.3671 65.0234 9.13826 66.556 9.13826Z"
          fill="#F1F5F9"
        />
        <path
          d="M77.1984 17.6266C78.2423 17.6266 79.8364 17.0715 80.4106 15.8616V17.3704H82.4935V7.4397H80.4106V12.844C80.4106 14.9079 78.8353 15.6718 77.54 15.6718C76.2447 15.6718 75.2863 14.6944 75.2863 13.0575V7.4397H73.2033V13.1192C73.1843 15.947 74.6931 17.6266 77.2032 17.6266H77.1984Z"
          fill="#F1F5F9"
        />
        <path
          d="M86.5647 12.0324C86.5647 9.9685 88.1399 9.22359 89.4352 9.22359C90.7305 9.22359 91.689 10.201 91.689 11.8189V17.3702H93.7719V11.6908C93.7908 8.86298 92.3058 7.18335 89.7959 7.18335C88.733 7.18335 87.1387 7.73848 86.5647 8.97212V7.43957H84.4817V17.375H86.5647V12.0324Z"
          fill="#F1F5F9"
        />
        <path
          d="M96.1443 22.2006H98.3601L104.528 7.4397H102.27L99.4229 14.3528L96.5713 7.4397H94.3176L98.2936 16.9245L96.1443 22.2006Z"
          fill="#F1F5F9"
        />
        <path
          d="M109.434 17.6266C110.967 17.6266 112.329 16.8389 112.964 15.6907V17.3702H115.047V7.43957H112.964V8.92941C112.324 7.80016 110.967 7.18335 109.52 7.18335C106.711 7.18335 104.604 9.4371 104.604 12.3931C104.604 15.349 106.839 17.6266 109.434 17.6266ZM109.757 9.13818C111.351 9.13818 112.946 10.4762 112.946 12.3931C112.946 14.3099 111.456 15.6669 109.795 15.6669C108.049 15.6669 106.711 14.1771 106.711 12.3931C106.711 10.6091 108.049 9.13818 109.752 9.13818H109.757Z"
          fill="#F1F5F9"
        />
        <path
          d="M119.104 12.0324C119.104 9.9685 120.68 9.22359 121.975 9.22359C123.27 9.22359 124.228 10.201 124.228 11.8189V17.3702H126.312V11.6908C126.33 8.86298 124.846 7.18335 122.336 7.18335C121.273 7.18335 119.679 7.73848 119.104 8.97212V7.43957H117.021V17.375H119.104V12.0324Z"
          fill="#F1F5F9"
        />
        <path
          d="M63.4912 23.5292L64.8434 25.1992L66.5326 23.8708C66.5326 23.8708 65.8351 22.9408 65.2041 22.1816C64.2551 22.7083 63.496 23.5339 63.496 23.5339L63.4912 23.5292Z"
          fill="#F1F5F9"
        />
        <path
          d="M67.7566 25.4084C68.1978 26.8034 68.4541 28.1937 68.4541 29.3988C68.4541 30.3477 68.307 31.2777 68.0507 31.9752C67.4197 32.4402 66.7222 32.5873 65.8112 32.5873C63.9513 32.5873 62.8362 31.7427 62.8362 29.7166C62.8362 28.9148 62.9833 28.132 63.1731 27.4772C62.58 27.2874 62.0961 27.183 61.484 27.183C61.2326 28.0276 61 28.9338 61 30.1389C61 33.0949 62.4993 34.6987 65.4553 34.6987C67.1445 34.6987 68.3686 34.1293 69.1515 33.1566C69.9534 32.184 70.3329 30.604 70.3567 29.0382C70.3567 27.5816 70.2096 25.9778 69.8917 24.6445C69.1088 24.7062 68.3496 24.9814 67.7613 25.4037L67.7566 25.4084Z"
          fill="#F1F5F9"
        />
        <path
          d="M112.267 33.8964C112.016 33.5359 111.593 33.0091 111.214 32.5679C110.265 33.0945 109.506 33.9201 109.506 33.9201L110.858 35.5903L112.528 34.2617L113.605 35.5903L115.294 34.2617C115.294 34.2617 114.597 33.3128 113.966 32.5727C113.121 33.0376 112.424 33.754 112.277 33.9011L112.267 33.8964Z"
          fill="#F1F5F9"
        />
        <path
          d="M117.463 21.1234L118.815 22.7936L120.504 21.465C120.504 21.465 119.807 20.5351 119.176 19.7759C118.227 20.3026 117.467 21.1281 117.467 21.1281L117.463 21.1234Z"
          fill="#F1F5F9"
        />
        <path
          d="M122.383 33.9393L123.735 35.6094L125.424 34.2809C125.424 34.2809 124.727 33.3319 124.096 32.5918C123.147 33.1184 122.387 33.944 122.387 33.944L122.383 33.9393Z"
          fill="#F1F5F9"
        />
        <path
          d="M126.036 23.1732C125.296 23.1922 124.347 23.5766 123.84 23.9324C124.262 24.9667 124.537 26.2146 124.537 27.1825C124.537 27.5432 124.518 27.8374 124.409 28.2169H121.979C120.883 28.2169 120.144 28.1742 119.531 27.9227C119.935 27.0354 120.272 25.9394 120.523 24.796C119.972 24.5208 119.213 24.3737 118.326 24.4163C118.155 25.854 117.923 26.9311 117.377 28.2169H115.859C114.677 28.2169 113.766 28.1552 113.116 27.9227C113.52 27.0354 113.876 25.9394 114.132 24.796C113.562 24.5208 112.822 24.3547 111.935 24.4163C111.745 25.854 111.513 26.9311 110.986 28.2169H75.5523C75.5523 28.2169 75.5475 28.2169 75.5429 28.2169C75.5429 28.2169 75.538 28.2169 75.5334 28.2169H73.9059V18.4712C72.8098 18.4712 72.0887 18.7227 71.4766 19.1259C71.7518 23.4769 71.9842 26.7366 72.1504 30.4754H75.5381C75.5381 30.4754 75.5429 30.4754 75.5475 30.4754H111.802C112.054 30.1385 112.243 29.8016 112.561 29.2086C113.235 30.0673 114.426 30.4706 115.83 30.4754H118.217C118.468 30.1385 118.658 29.8016 118.957 29.2086C119.626 30.0673 120.76 30.4706 121.951 30.4754H125.752C126.217 29.2275 126.449 27.6903 126.449 26.4234C126.449 25.4935 126.321 24.1839 126.027 23.1732H126.036Z"
          fill="#F1F5F9"
        />
      </g>
      <path
        d="M153.108 17.375L158.09 20.2693L163.072 17.375L158.09 14.4761L153.108 17.375Z"
        fill="#7EC7BD"
      />
      <path
        d="M148.121 20.2693V26.0579L153.108 23.1636L148.121 20.2693Z"
        fill="#7EC7BD"
      />
      <path
        d="M148.121 8.6875V14.476L153.108 17.3752V11.5818L148.121 8.6875Z"
        fill="#7EC7BD"
      />
      <path
        d="M133.176 28.9572L138.158 31.8515L143.139 28.9572L138.158 26.0581L133.176 28.9572Z"
        fill="#7EC7BD"
      />
      <path
        d="M148.121 37.6444V31.8511L143.139 34.7454L148.121 37.6444Z"
        fill="#7EC7BD"
      />
      <path
        d="M143.139 28.9572L148.121 26.0581L143.139 23.1641V28.9572Z"
        fill="#7EC7BD"
      />
      <path
        d="M163.072 23.164L168.054 20.2698L163.072 17.3752V23.164Z"
        fill="#7EC7BD"
      />
      <path
        d="M168.054 14.4763L173.036 17.3754V11.582L168.054 14.4763Z"
        fill="#7EC7BD"
      />
      <path
        d="M183 17.375L178.018 14.4761L173.036 17.3753L178.018 20.2693L183 17.375Z"
        fill="#7EC7BD"
      />
      <path
        d="M178.018 31.8515L183 28.9572L178.018 26.0581V31.8515Z"
        fill="#7EC7BD"
      />
      <path
        d="M153.108 28.9572L158.09 31.8515L163.072 28.9572L158.09 26.0581L153.108 28.9572Z"
        fill="#7EC7BD"
      />
      <path
        d="M168.054 2.89429V8.6876L173.036 5.79332L168.054 2.89429Z"
        fill="#7EC7BD"
      />
      <path
        d="M133.176 17.3752V23.1638L138.158 20.2695L133.176 17.3752Z"
        fill="#7EC7BD"
      />
      <path
        d="M143.14 11.582L138.158 14.4763L143.14 17.3754V11.582Z"
        fill="#7EC7BD"
      />
      <path
        d="M158.09 20.2693L148.121 14.4761V20.2693L153.108 23.1636L158.09 20.2693Z"
        fill="#24AE81"
      />
      <path
        d="M153.108 5.79321L148.121 8.6875L153.108 11.5818V5.79321Z"
        fill="#24AE81"
      />
      <path
        d="M158.09 14.4763L163.072 17.3754V11.582L158.09 14.4763Z"
        fill="#24AE81"
      />
      <path
        d="M138.158 31.8515L143.14 34.7458L148.122 31.8515V26.0581L138.158 31.8515Z"
        fill="#24AE81"
      />
      <path
        d="M163.072 17.3753L168.054 20.2693L173.036 17.375L168.054 14.4761L163.072 17.3753Z"
        fill="#24AE81"
      />
      <path
        d="M178.018 20.2698L173.036 17.3752V23.164L178.018 20.2698Z"
        fill="#24AE81"
      />
      <path
        d="M178.018 14.4763L183 17.3754V11.582L178.018 14.4763Z"
        fill="#24AE81"
      />
      <path
        d="M183 28.9574V23.1641L178.018 26.0583L183 28.9574Z"
        fill="#24AE81"
      />
      <path
        d="M163.072 28.9574V23.1641L158.09 26.0583L163.072 28.9574Z"
        fill="#24AE81"
      />
      <path
        d="M153.108 34.7458L158.09 31.8516L153.108 28.9573V34.7458Z"
        fill="#24AE81"
      />
      <path d="M173.036 0L168.054 2.89429L173.036 5.79333V0Z" fill="#24AE81" />
      <path
        d="M138.158 20.2693L133.176 23.1636V28.9568L138.158 26.0579V20.2693Z"
        fill="#24AE81"
      />
      <path
        d="M138.158 8.6875V14.476L143.14 11.5818L138.158 8.6875Z"
        fill="#24AE81"
      />
      <defs>
        <clipPath id="clip0_4774_62783">
          <rect
            width="127.175"
            height="33.574"
            fill="white"
            transform="translate(0 2.0354)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default BunyanTextLogo;
